import { useState, useEffect } from "react";

export interface BurnRateProfile {
  businessName: string;
  plan: "pro" | "free";
  category: "servicio" | "gastronomia" | "producto";
  subcategory: string;
}

export const CATEGORY_LABELS: Record<BurnRateProfile["category"], string> = {
  servicio:    "Servicio",
  gastronomia: "Gastronomía",
  producto:    "Producto",
};

export const SUBCATEGORIES: Record<BurnRateProfile["category"], string[]> = {
  servicio:    ["Fotógrafo", "Diseñador", "Consultor", "Coach", "Programador", "Marketing", "Abogado", "Otros"],
  gastronomia: ["Restaurante", "Cafetería", "Food Truck", "Catering", "Pastelería", "Otros"],
  producto:    ["Artesanía", "Ropa", "Cosmética", "Electrónica", "Muebles", "Otros"],
};

const STORAGE_KEY = "prodigium:burn-rate:profile";

const DEFAULT: BurnRateProfile = {
  businessName: "Mi Negocio",
  plan: "free",
  category: "servicio",
  subcategory: "Fotógrafo",
};

// TODO: Replace localStorage reads/writes with Supabase when account system is ready.
//       Target query: supabase.from("profiles").select("burn_rate_settings").single()
//       Target write:  supabase.from("profiles").update({ burn_rate_settings: next }).eq("id", uid)
export function useBurnRateProfile() {
  const [profile, setProfile] = useState<BurnRateProfile>(DEFAULT);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) setProfile(JSON.parse(stored) as BurnRateProfile);
    } catch {}
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
    } catch {}
  }, [profile]);

  const update = (updates: Partial<BurnRateProfile>) => {
    setProfile((prev) => {
      const next = { ...prev, ...updates };
      if (updates.category && updates.category !== prev.category) {
        next.subcategory = SUBCATEGORIES[updates.category][0];
      }
      return next;
    });
  };

  return { profile, update };
}
